import React, { useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import EscapeHero from "../components/site/escape/EscapeHero";
import EscapeNarrative from "../components/site/escape/EscapeNarrative";
import EscapeGallery from "../components/site/escape/EscapeGallery";
import SubRetreatsGrid from "../components/site/escape/SubRetreatsGrid";
import DateDialog from "../components/site/escape/DateDialog";
import { DESTINATIONS } from "../data/destinations";
import { getSubRetreats } from "../data/subRetreats";
import { getEscapeNarrative } from "../data/escapeNarrative";
import { getGallery } from "../data/gallery";
import { useSeo } from "../hooks/useSeo";
import { escapeTitle, escapeDescription } from "../lib/seoText";

export default function EscapeDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const parent = DESTINATIONS.find((d) => d.id === id);
  const [pending, setPending] = useState(null);

  useSeo(
    parent
      ? {
          title: escapeTitle(parent),
          description: escapeDescription(parent),
          path: `/escape/${parent.id}`,
          image: parent.image,
        }
      : {
          title: "Escape not found (404) | YogaToYacht",
          description: "We couldn't find that retreat. Browse curated yoga, wellness and yacht escapes on YogaToYacht.",
          path: `/escape/${id}`,
          noindex: true,
        }
  );

  if (!parent) {
    return (
      <div className="min-h-screen bg-brand-bg text-brand-ink">
        <Header onNavigate={() => navigate("/")} />
        <div className="mx-auto max-w-3xl px-6 pt-40 pb-24 text-center">
          <h1 className="font-display text-4xl">Escape not found</h1>
          <p className="mt-3 text-brand-inkSoft">We couldn&apos;t find that retreat. Head back to the menu.</p>
          <Link to="/" data-testid="back-home" className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-sm font-medium text-white">Back to home</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const subs = getSubRetreats(parent);
  const narrative = getEscapeNarrative(parent);
  const photos = getGallery(parent);

  return (
    <div data-testid="escape-detail-page" className="bg-brand-bg text-brand-ink">
      <Header onNavigate={() => navigate("/")} />
      <EscapeHero parent={parent} onBack={() => navigate("/")} />
      <EscapeNarrative narrative={narrative} />
      <EscapeGallery parent={parent} photos={photos} />
      <SubRetreatsGrid parent={parent} subs={subs} onSelect={setPending} />
      <Footer />
      <DateDialog parent={parent} pending={pending} onClose={() => setPending(null)} />
    </div>
  );
}
